<template>
    <div class="card">
        <div class="container-fluid">
             <div class="row my-3">
                <div class="col-md-4">
                    <button @click.prevent="download()" style="height:41px;min-height:41px;" class="btn btn-success my-2 my-sm-0" >Export</button>
                </div>
                <div class="col-md-8">
                    <a class="btn btn-info float-right" href="/report"><i class="fa fa-angle-left" aria-hidden="true"></i> Back</a>
                </div>
            </div>
            <table id="my-table" class="table table-sm">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">ব্যাংকের নাম</th>
                        <th scope="col">ব্যাংকের ঠিকানা</th>
                        <th scope="col">হিসাব নং</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(datum,key) in data.data" :key="key">
                        <td>{{key+1}}</td>
                        <td>{{datum.name}}</td>
                        <td>{{datum.address}}</td>
                        <td>{{datum.account_no}}</td>
                    </tr>
                </tbody>
            </table>
            <nav  aria-label="Page navigation example">
                <pagination :limit="5" :data="data" @pagination-change-page="getResults"></pagination>
            </nav>
        </div>
    </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import axios from 'axios';
import pagination from 'laravel-vue-pagination'

export default {
    data(){
        return {
            data:{}
        }
    },
    methods:{
        getResults(page=1){
            var data = {page};
            if(this.date){
                data = {page};
            }
            axios.post('/api/bank-report?page='+page,data).then(response=>{
                this.data = response.data;
                //console.log(this.data);
            })
        },
        download(){
            var download = 'download'
            window.open(`${axios.defaults.baseURL}/api/bank-report?&download=${download}`);
        }
    },
    mounted(){
        this.getResults();
    },
    computed: {

    },
    components: {
        VueCtkDateTimePicker,
        pagination
    }
}
</script>
<style scoped>
.field-input{
    height: 30px !important;
}
 .actn{
     margin-left: 10px;
     cursor: pointer;
 }
 .contct{
     padding-bottom: 10px;
     padding-top: 10px
 }
 .contct-b{
     margin-bottom: 10px;
     margin-top: 10px
 }
 .load{
     margin-left: 50%;
 }
 .btn-info{ color: #fff; text-transform: capitalize; height: 42px; line-height: 42px; padding: 0rem 0.75rem;}
</style>
